<ag-task (goBackEvent)="goBackEvent.emit($event)" [isUrlMode]="isUrlMode" [selectedFeatureMode]="selectedFeatureMode"
         [sidebarEl]="featureComponentSidebarEl" [urlModeGoBackUrl]="urlModeGoBackUrl" class="full-height-container"
         id="task-component">
  <ng-template agClassifier="{{FeatureComponentMode.ADD_ROW}}">
    <unique-link-invitees-detail
      class="task-component-detail full-height-container"></unique-link-invitees-detail>
  </ng-template>
  <ng-template agClassifier="{{FeatureComponentMode.EDIT_ROW}}">
    <unique-link-invitees-detail
      class="task-component-detail full-height-container"></unique-link-invitees-detail>
  </ng-template>
  <ng-template agClassifier="{{FeatureComponentMode.BULK_MAILOUT}}">
    <app-unique-link-invitees-bulk (goBackEvent)="goBackEvent.emit($event)"
                                   [featureComponentMode]="FeatureComponentMode.BULK_MAILOUT"
                                   [selectedRows]="selectedRows"
                                   class="task-component-detail full-height-container"></app-unique-link-invitees-bulk>
  </ng-template>
  <ng-template agClassifier="{{FeatureComponentMode.BULK_EDIT}}">
    <app-unique-link-invitees-bulk (goBackEvent)="goBackEvent.emit($event)"
                                   [featureComponentMode]="FeatureComponentMode.BULK_EDIT"
                                   [selectedRows]="selectedRows"
                                   class="task-component-detail full-height-container"></app-unique-link-invitees-bulk>
  </ng-template>
  <ng-template agClassifier="{{FeatureComponentMode.UPLOAD}}">
    <app-unique-link-invitees-bulk (goBackEvent)="goBackEvent.emit($event)"
                                   [featureComponentMode]="FeatureComponentMode.UPLOAD"
                                   class="task-component-detail full-height-container"></app-unique-link-invitees-bulk>
  </ng-template>
</ag-task>
